// extracted by mini-css-extract-plugin
export default {"list":"InfiniteList_list__mtdjn","placeholder":"InfiniteList_placeholder__4ZeMG"};